export class Project {
    projectId: number;
    name: string;
    description: string;
    customerId: number;
    category: string;
    companyName: string;
    active: boolean;
    number: string;
    pincode: string;
    favourite: boolean;
    timeStamp: Date;
    projectSize: number;
    usageValue: number;
    launchCount: number;
}